function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import closest from '../../../shared/utils/closest/closest.mjs';
import distance from '../../../shared/utils/distance/distance.mjs';
import touchCoords from '../../../shared/utils/touchCoords/touchCoords.mjs';
import Sensor from '../Sensor/Sensor.mjs';
import { DragStartSensorEvent, DragMoveSensorEvent, DragStopSensorEvent } from '../SensorEvent/SensorEvent.mjs';
var onTouchStart = Symbol('onTouchStart');
var onTouchEnd = Symbol('onTouchEnd');
var onTouchMove = Symbol('onTouchMove');
var startDrag = Symbol('startDrag');
var onDistanceChange = Symbol('onDistanceChange');
var preventScrolling = false;
window.addEventListener('touchmove', function (event) {
  if (!preventScrolling) {
    return;
  }

  event.preventDefault();
}, {
  passive: false
});

var TouchSensor = /*#__PURE__*/function (_Sensor) {
  _inherits(TouchSensor, _Sensor);

  var _super = _createSuper(TouchSensor);

  function TouchSensor() {
    var _this;

    var containers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, TouchSensor);

    _this = _super.call(this, containers, options);
    _this.currentScrollableParent = null;
    _this.tapTimeout = null;
    _this.touchMoved = false;
    _this.pageX = null;
    _this.pageY = null;
    _this[onTouchStart] = _this[onTouchStart].bind(_assertThisInitialized(_this));
    _this[onTouchEnd] = _this[onTouchEnd].bind(_assertThisInitialized(_this));
    _this[onTouchMove] = _this[onTouchMove].bind(_assertThisInitialized(_this));
    _this[startDrag] = _this[startDrag].bind(_assertThisInitialized(_this));
    _this[onDistanceChange] = _this[onDistanceChange].bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(TouchSensor, [{
    key: "attach",
    value: function attach() {
      document.addEventListener('touchstart', this[onTouchStart]);
    }
  }, {
    key: "detach",
    value: function detach() {
      document.removeEventListener('touchstart', this[onTouchStart]);
    }
  }, {
    key: onTouchStart,
    value: function value(event) {
      var _this2 = this;

      var container = closest(event.target, this.containers);

      if (!container) {
        return;
      }

      if (this.options.handle && event.target && !closest(event.target, this.options.handle)) {
        return;
      }

      var originalSource = closest(event.target, this.options.draggable);

      if (!originalSource) {
        return;
      }

      var _this$options$distanc = this.options.distance,
          distance = _this$options$distanc === void 0 ? 0 : _this$options$distanc;
      var delay = this.delay;

      var _touchCoords = touchCoords(event),
          pageX = _touchCoords.pageX,
          pageY = _touchCoords.pageY;

      Object.assign(this, {
        pageX: pageX,
        pageY: pageY
      });
      this.onTouchStartAt = Date.now();
      this.startEvent = event;
      this.currentContainer = container;
      this.originalSource = originalSource;
      document.addEventListener('touchend', this[onTouchEnd]);
      document.addEventListener('touchcancel', this[onTouchEnd]);
      document.addEventListener('touchmove', this[onDistanceChange]);
      container.addEventListener('contextmenu', onContextMenu);

      if (distance) {
        preventScrolling = true;
      }

      this.tapTimeout = window.setTimeout(function () {
        _this2[onDistanceChange]({
          touches: [{
            pageX: _this2.pageX,
            pageY: _this2.pageY
          }]
        });
      }, delay.touch);
    }
  }, {
    key: startDrag,
    value: function value() {
      var startEvent = this.startEvent;
      var container = this.currentContainer;
      var touch = touchCoords(startEvent);
      var originalSource = this.originalSource;
      var dragStartEvent = new DragStartSensorEvent({
        clientX: touch.pageX,
        clientY: touch.pageY,
        target: startEvent.target,
        container: container,
        originalSource: originalSource,
        originalEvent: startEvent
      });
      this.trigger(this.currentContainer, dragStartEvent);
      this.dragging = !dragStartEvent.canceled();

      if (this.dragging) {
        document.addEventListener('touchmove', this[onTouchMove]);
      }

      preventScrolling = this.dragging;
    }
  }, {
    key: onDistanceChange,
    value: function value(event) {
      var distance$1 = this.options.distance;
      var startEvent = this.startEvent,
          delay = this.delay;
      var start = touchCoords(startEvent);
      var current = touchCoords(event);
      var timeElapsed = Date.now() - this.onTouchStartAt;
      var distanceTravelled = distance(start.pageX, start.pageY, current.pageX, current.pageY);
      Object.assign(this, current);
      clearTimeout(this.tapTimeout);

      if (timeElapsed < delay.touch) {
        document.removeEventListener('touchmove', this[onDistanceChange]);
      } else if (distanceTravelled >= distance$1) {
        document.removeEventListener('touchmove', this[onDistanceChange]);
        this[startDrag]();
      }
    }
  }, {
    key: onTouchMove,
    value: function value(event) {
      if (!this.dragging) {
        return;
      }

      var _touchCoords2 = touchCoords(event),
          pageX = _touchCoords2.pageX,
          pageY = _touchCoords2.pageY;

      var target = document.elementFromPoint(pageX - window.scrollX, pageY - window.scrollY);
      var dragMoveEvent = new DragMoveSensorEvent({
        clientX: pageX,
        clientY: pageY,
        target: target,
        container: this.currentContainer,
        originalEvent: event
      });
      this.trigger(this.currentContainer, dragMoveEvent);
    }
  }, {
    key: onTouchEnd,
    value: function value(event) {
      clearTimeout(this.tapTimeout);
      preventScrolling = false;
      document.removeEventListener('touchend', this[onTouchEnd]);
      document.removeEventListener('touchcancel', this[onTouchEnd]);
      document.removeEventListener('touchmove', this[onDistanceChange]);

      if (this.currentContainer) {
        this.currentContainer.removeEventListener('contextmenu', onContextMenu);
      }

      if (!this.dragging) {
        return;
      }

      document.removeEventListener('touchmove', this[onTouchMove]);

      var _touchCoords3 = touchCoords(event),
          pageX = _touchCoords3.pageX,
          pageY = _touchCoords3.pageY;

      var target = document.elementFromPoint(pageX - window.scrollX, pageY - window.scrollY);
      event.preventDefault();
      var dragStopEvent = new DragStopSensorEvent({
        clientX: pageX,
        clientY: pageY,
        target: target,
        container: this.currentContainer,
        originalEvent: event
      });
      this.trigger(this.currentContainer, dragStopEvent);
      this.currentContainer = null;
      this.dragging = false;
      this.startEvent = null;
    }
  }]);

  return TouchSensor;
}(Sensor);

function onContextMenu(event) {
  event.preventDefault();
  event.stopPropagation();
}

export { TouchSensor as default };